import { useQuery } from "@apollo/client";
import { Label, Spinner, TextInputField } from "evergreen-ui";
import React, { useState } from "react";
import useInput from "src/Hooks/useInput";
import styled from "styled-components";
import { GET_USERS_BY_USERNAME_NAME } from "../../Queries/users.shared";

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  position: relative;
`;

const ItemsContainer = styled.div`
  position: absolute;
  top: 80%;
  background-color: white;
  border-radius: 0.4rem;
  width: 100%;
  overflow-y: auto;
  max-height: 60vh;
  z-index: 10;
  box-shadow: ${(props) => props.theme.boxShadow};
`;

const Item = styled.div`
  cursor: pointer;
  padding: 0.8rem;
  width: 100%;
  :hover {
    background-color: ${(props) => props.theme.extraLightGreyColor};
  }
`;
const LoadingContainer = styled.div`
  width: 100%;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
interface IProps {
  label: string;
  onSelect: any;
  currentValue?: string;
}
const UserSelector: React.SFC<IProps> = ({ label, onSelect, currentValue }) => {
  const searchInput = useInput(currentValue || "");
  const [show, setShow] = useState(false);
  const { data, loading, error } = useQuery(GET_USERS_BY_USERNAME_NAME, {
    variables: {
      search: searchInput.value + "%",
    },
  });

  const [selectedUser, setSelectedUser] = useState("");

  return (
    <Container>
      <TextInputField
        onFocus={() => {
          setShow(true);
        }}
        onBlur={() => {
          setTimeout(() => {
            setShow(false);
          }, 300);
        }}
        autoComplete={"off"}
        label={label}
        hint={selectedUser}
        placeholder="Search user by name or username"
        value={searchInput.value}
        onChange={(e) => {
          setShow(true);
          searchInput.onChange(e);
        }}
      />
      {show && (
        <ItemsContainer>
          {loading && (
            <LoadingContainer>
              <Spinner />
            </LoadingContainer>
          )}
          {!loading && error && <Label>Error: {error.message}</Label>}
          {!loading &&
            data &&
            data.users &&
            (data.users.length > 0 ? (
              data.users.map((user, index) => (
                <Item
                  onClick={() => {
                    setShow(false);
                    searchInput.onChange(user.name);
                    setSelectedUser(user.name + " (" + user.username + ")");
                    onSelect(user.id);
                  }}
                  key={index}
                >
                  {user.name} ({user.username})
                </Item>
              ))
            ) : (
              <Label>No user found!</Label>
            ))}
        </ItemsContainer>
      )}
    </Container>
  );
};

export default UserSelector;
